<div class="panel">
  <div class="border-b border-gray-200">
    <div class="px-8 h-20 items-center flex gap-3">
      <!-- The list heading is the button that opens its menu (TW-PANEL-07): named by its text, Enter and Space native. -->
      <button
        type="button"
        class="bg-transparent border-0 p-0 [font:inherit] text-inherit text-left cursor-pointer"
        appDPTasksContextMenu
        (appDPContextMenuOpened)="contextMenuOpened = $event"
        (appDPContextMenuFilterChanged)="selectFilter($event)"
        aria-haspopup="menu"
        [attr.aria-expanded]="!!contextMenuOpened"
      >
        <app-dropdown-label [collapsed]="!contextMenuOpened">
          {{ selectedFilter | titleByTasksFilter }}
        </app-dropdown-label>
      </button>

      <div class="grow"></div>

      @if (selectedTab !== 'projects') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appTasksListContextMenu
          [appTasksListContextMenuWithAdvancedSearch]="true"
        />
      }

      @if (selectedTab === 'projects') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appProjectsListContextMenu
          [appProjectsListContextMenuWithAdvancedSearch]="true"
        />
      }

      <app-search-state-indicator [applied]="isSearchApplied()" (clear)="clearSearch()">
        <app-icon
          class="max-w-8 max-h-8 text-gray-500 cursor-pointer items-center"
          name="search-small"
          stchPopover
          stchPopoverPlacement="bottomRight"
          stchPopoverTrigger="click"
          [stchPopoverContent]="searchPopover"
          [stchPopoverFallbackPlacements]="[]"
          [stchPopoverShowUntil]="popoverClose"
        />
      </app-search-state-indicator>
    </div>
    @if (listState === 'tabs') {
      <app-tabs class="panel-heading-tabs" [values]="tabs" [(value)]="selectedTab" />
    }
  </div>

  @if (selectedTab === 'tasks' && creationAllowed()) {
    <app-quick-form class="panel-quick-form" trigger="button" [collapseKey]="selectedFilter" placeholder="Add New Task">
      <app-task-quick-form
        [showMore]="true"
        [destinationTenantId]="tasksTenantScope.effectiveTenantId() ?? undefined"
        (more)="handleNewTask($event)"
      />
    </app-quick-form>
  }

  @if (selectedTab === 'projects' && creationAllowed()) {
    <app-quick-form
      class="panel-quick-form"
      trigger="button"
      [collapseKey]="selectedFilter"
      placeholder="Add New Project"
    >
      <app-project-quick-form
        [showMore]="true"
        [destinationTenantId]="tasksTenantScope.effectiveTenantId() ?? undefined"
        (more)="handleNewProject($event)"
      />
    </app-quick-form>
  }

  <div class="panel-list border-t border-gray-200">
    @if (selectedTab !== 'projects') {
      <app-tasks-list
        [filters]="tasksFilters"
        [showLocationBadge]="isAdvancedSearchApplied()"
        (openTask)="openTask($event)"
        (openSubtask)="openTaskInModal($event)"
        (doubleClickTask)="openTask($event)"
      />
    }

    @if (selectedTab === 'projects') {
      <app-projects-list
        [filters]="projectsFilters"
        (openProject)="openProject($event)"
        (openTask)="openTaskInModal($event)"
        (doubleClickProject)="openProject($event)"
      />
    }
  </div>
</div>

<ng-template #searchPopover>
  <app-tasking-search-popover [width]="600" (onSearch)="handleSearch()" (onCancel)="handleCancel()" />
</ng-template>
